import { useState, useEffect, useContext } from "react";
import StatCard from "../components/dashboard/Cards";
import DevicePackage from "../components/dashboard/DevicePackage";
import LicenseCard from "../components/dashboard/LicenseCard";
import LiveAgents from "../components/dashboard/LiveAgents";
import LicenseUtilisedTable from "../components/dashboard/UtilisedTable";
import { Box, Container, Modal } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faCircleCheck, faLock, faClock, faFileShield, faFingerprint ,faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { getDashboard, getCompanyDashboard ,getLiveAgents,dashLicenceData } from "../apis/axios";
import AuthContext from "../AuthContext";

// Helper function to format data size (from bytes to GB, MB, KB, starting from KB) with single digit before decimal and 4 digits after
const formatDataSize = (sizeInBytes) => {
  if (sizeInBytes === null || sizeInBytes === undefined || isNaN(sizeInBytes)) {
    return "-";
  }

  const bytes = parseFloat(sizeInBytes);
  let value = bytes / 1024; // Convert to KB immediately (start from KB)
  let unit = "KB";

  // Convert to appropriate unit
  if (value >= 1024 * 1024) { // GB
    value = value / (1024 * 1024);
    unit = "GB";
  } else if (value >= 1024) { // MB
    value = value / 1024;
    unit = "MB";
  }

  // If the value is 0, return early with proper formatting
  if (value === 0) {
    return `0.0000 ${unit}`;
  }

  // Ensure single digit before decimal for GB, MB, KB
  while (value >= 10) {
    value = value / 10;
  }
  // Format to 4 decimal places
  value = value.toFixed(4);
  // If the value is less than 1, display as 0.XXXX
  if (value < 1) {
    value = `0.${value.split('.')[1]}`;
  }

  return `${value} ${unit}`;
};


const Dashboard = () => {
  const auth = useContext(AuthContext);
  const [dashboardData, setDashboardData] = useState(null);
  const [agentsData, setAgentsData] = useState(null);
  const [licenceData,setLicenceData]=useState(null)
  const [overViewData,setOverViewData]=useState(null)
  const [deviceData,setDeviceData]=useState(null)
   //console.log(auth.admin)

  const [loading,setLoading]=useState(false)
  const fetchLiveAgents = async () => {
    if (auth.userType!=='antima' &&!auth?.admin) return; // wait until admin is loaded
    setLoading(true)
    try {
      const response = await getLiveAgents({company_id: auth.admin}); 

      //console.log("Live Agents Data:", response.data);
      setAgentsData(response.data);
    } catch (error) {
      console.error("Error fetching live agents:", error);
    }
    setLoading(false)
  };
  //console.log(agentsData);
  const fetchData = async () => {
    if (auth.userType!=='antima' &&!auth?.admin) return; // wait until admin is loaded
    setLoading(true)
    try {
      let response
      if(auth.userType==='antima'){
        response=await getDashboard()
      }
      else{
         response = await getCompanyDashboard({ company_id: auth.admin });
      }
        //console.log(response)
      //console.log("Dashboard Data:", response.data);
      setDashboardData(response.data);
    
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
    setLoading(false)
  };
const getLicence=async()=>{
  if (auth.userType!=='antima' &&!auth?.admin) return; // wait until admin is loaded
  setLoading(true)
  try {
    const res=await dashLicenceData({company_id: auth.admin})
    setLicenceData(res.data.license_details)
    //console.log(res.data)
    setOverViewData(res.data.license_summary)
    setDeviceData(res.data.devices_data)
    setLoading(false)
  } catch (error) {
    console.error(error)
  }
}
//console.log(auth.admin)
 useEffect(() => {
  if (auth.userType!=='antima' &&!auth?.admin) return; // wait until admin is loaded
  fetchData();
  fetchLiveAgents();
  getLicence();
}, [auth.admin]);

  // Map your API data to the stats cards, with fallback values
  const stats = [
    {
      title: "Total Connected Devices",
      value: dashboardData ? dashboardData?.devices.totalDevices || "0" : "0",
      percentage: dashboardData ? `+${dashboardData.devices.todayDevices} devices today` : "0",
      icon: <FontAwesomeIcon icon={faDesktop} />,
      iconColor: "text-[#FF7A00]",
      iconBg: "bg-[#FFF3E5]",
      borderColor: "border-l-[#FF7A00]",
      textColor: "text-[#FF7A00]",
    },
    {
      title: "Total Wipes Completed",
      value: dashboardData ? dashboardData.totalWipes.total || "0" : "0",
      percentage: dashboardData ? `+${dashboardData.totalWipes.today} today` : "0",
      icon: <FontAwesomeIcon icon={faCircleCheck} />,
      iconColor: "text-[#42A487]",
      iconBg: "bg-[#E9F9EF]",
      borderColor: "border-l-[#42A487]",
      textColor: "text-[#42A487]",
    },
    {
      title: "Encrypted Data",
      value: dashboardData ? formatDataSize(dashboardData.encryption.totalDataEncrypted) : "-",
      percentage: dashboardData ? (dashboardData.encryption.todayDataEncrypted !== null ? `+${formatDataSize(dashboardData.encryption.todayDataEncrypted)} today` : "-") : "-",
      icon: <FontAwesomeIcon icon={faLock} />,
      iconColor: "text-[#8E44AD]",
      iconBg: "bg-[#F3EAFB]",
      borderColor: "border-l-[#8E44AD]",
      textColor: "text-[#8E44AD]",
    },
    {
      title: "Total Wipes Pending",
      value: dashboardData ? dashboardData.wipesPending.total || "0" : "0",
      percentage: dashboardData ? `+${dashboardData.wipesPending.today} today` : "0",
      icon: <FontAwesomeIcon icon={faClock} />,
      iconColor: "text-[#FFAA00]",
      iconBg: "bg-[#FCEDEC]",
      borderColor: "border-l-[#FFAA00]",
      textColor: "text-[#FFAA00]",
    },
    {
      title: "Deletion Requested",
      value: dashboardData ? dashboardData.encryption.fileEncrypted || "0" : "0",
      percentage: dashboardData ? `+${dashboardData.encryption.todayFileEncrypted} today` : "0",
      icon: <FontAwesomeIcon icon={faFileShield} />,
      iconColor: "text-[#34495E]",
      iconBg: "bg-[#ECF0F1]",
      borderColor: "border-l-[#34495E]",
      textColor: "text-[#34495E]",
    },
    {
      title: "Failed Deletions",
      value: dashboardData ? dashboardData.encryptionPending.total || "-" : "-",
      percentage: dashboardData ? `+${dashboardData.encryptionPending.today} in 24 hrs` : "-",
      icon: <FontAwesomeIcon icon={faTriangleExclamation} className="text-red-500 text-3xl" />,
      iconColor: "text-[#E74C3C]",
      iconBg: "bg-[#EAF4FB]",
      borderColor: "border-l-[#E74C3C]",
      textColor: "text-[#E74C3C]",
    },
  
  ];


  // Placeholder data for LiveAgents
  const liveAgents = {
    live: agentsData ? agentsData.active_devices : 0,
    offline: agentsData ? agentsData.inactive_devices : 0,
    total: agentsData ? agentsData.total_devices : 0,
  };

  return (
   <Box display="flex" sx={{ maxWidth: 'none', justifyContent: 'center' }}>
            <Box flexGrow={1} ml={{ sm: 0 }} sx={{ maxWidth: 'none' ,alignContent:"center" }}>
      {!loading &&(
        <div style={{ margin: '0 auto', width: '75.5vw', maxWidth: '75.5vw' }}>
        <h1
          style={{
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '32px',
            fontWeight: 700,
            color: '#202224',
            marginBottom: '1.5rem',
          }}
        >
          Dashboard
        </h1>
        <div className="flex flex-col gap-6">
          {/* First Row: Stat Cards and User Roles Chart */}
          <div className="grid grid-cols-1 lg:grid-cols-[3fr_1fr] gap-6">
            {/* Stat Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {stats.map((stat, idx) => (
                <StatCard key={idx} {...stat} />
              ))}
            </div>
            {/* User Roles Chart */}
            {!loading && (
              <div className="flex justify-end">
              <DevicePackage  Dashdata={deviceData}/>
            </div>
            )}
          </div>
          {/* Second Row: Live Agents and License Card Side by Side */}
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_4fr] gap-6">
            <div className="h-50">
              <LiveAgents live={liveAgents.live} offline={liveAgents.offline} total={liveAgents.total} />
            </div>
           {!loading &&(
             <div className="h-50">
              <LicenseCard licenseData={overViewData} />
            </div>
           )}
          </div>
          {/* Third Row: License Utilised Table */}
          {!loading &&
          <div>
            <LicenseUtilisedTable data={licenceData} />
          </div>
          }
        </div>
      </div>
      )}
    </Box>
    </Box>
  );
};

export default Dashboard;